import React from 'react';

import PageHelmet from './PageHelmet';
import Menu from '../../components/Menu';
import MenuProvider from '../../components/Menu/MenuProvider';

import * as T from './PageWrapper.types';

export const PageWrapper: React.FunctionComponent<T.IPageWrapperProps> = ({
  menuProps,
  children,
  helmetProps,
}) => {
  return (
    <>
      {helmetProps && <PageHelmet {...helmetProps} />}
      <MenuProvider>
        {menuProps && <Menu {...menuProps} />}
        {children}
      </MenuProvider>
    </>
  );
};
